import React from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <div className='w-full h-screen absolute top-0 right-0 z-50 bg-white flex items-center justify-center '>
      <div className='flex items-center justify-center flex-col gap-4 w-max px-8 py-4 rounded border'>
        <h2 className='font-bold text-3xl'>به نظر مشکلی پیش اومده</h2>
        <span className='font-bold text-yellow-600 border-b w-full text-center'>404</span>
        <img src="./icons/tenor.gif" alt="" />
        <div className='flex flex-col text-start gap-2'>
          <p className='font-bold '>لطفا موارد زیر را برسی کنید </p>
          <ul className='list-disc list-inside text-gray-600'>
            <li>اتصال دستگاه به اینترنت</li>
            <li>آدرس یا لینک وارد شده</li>
            <li>اتصال دستگاه به تحریم شکن</li>
          </ul>
        </div>
        <div>
          <Link to={"/"} className='bg-yellow-400  px-4 py-1 rounded '>
            بازگشت به صفحه اصلی
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound